"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompensatedBills = void 0;
const react_1 = __importDefault(require("react"));
const CompensatedBills = ({ size, color }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 84 84", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M19.688 56.873H8.75V45.937M61.25 45.936v10.938H50.312M8.75 24.061V13.124h10.938M21.875 24.061v21.875M39.375 24.061v21.875M30.625 24.061v21.875", stroke: color || '#25CFBB', strokeWidth: "4.375", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M45.992 23.572c-.036.157-.054.321-.054.49v21.874a2.188 2.188 0 0 0 4.374 0V28.418a11.047 11.047 0 0 1-4.32-4.846Z", fill: color || '#25CFBB' }),
        react_1.default.createElement("path", { d: "m46 14 6.391 7L64.5 8.892", stroke: color || '#25CFBB', strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.CompensatedBills = CompensatedBills;
